module.exports = __webpack_public_path__ + "img/search.ad101242.svg";